import { render, staticRenderFns } from "./PersonalIdCard.vue?vue&type=template&id=3334ef46&scoped=true&"
import script from "./PersonalIdCard.vue?vue&type=script&lang=ts&"
export * from "./PersonalIdCard.vue?vue&type=script&lang=ts&"
import style0 from "./PersonalIdCard.vue?vue&type=style&index=0&id=3334ef46&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3334ef46",
  null
  
)

export default component.exports